import { ResponsiveImage } from "@/components/site/ResponsiveImage";
import { Reveal } from "@/components/site/Reveal";
import { galleryPhotos } from "@/lib/gallery";
import { imageSizes } from "@/lib/images";
import { cn } from "@/lib/utils";

export function PhotoGallery() {
  const featured = galleryPhotos.find((photo) => photo.featured);
  const rest = galleryPhotos.filter((photo) => !photo.featured);
  if (!featured) return null;

  return (
    <section
      id="gallery"
      className="scroll-mt-28 border-b border-border bg-secondary/40 py-20 sm:py-28"
      aria-labelledby="gallery-heading"
    >
      <div className="mx-auto max-w-6xl px-4">
        <Reveal>
          <p className="eyebrow">Photo gallery</p>
          <h2 id="gallery-heading" className="mt-3 text-4xl uppercase sm:text-5xl">
            Work from the floor
          </h2>
          <p className="mt-4 max-w-2xl text-muted-foreground">
            Real engines and machine work from Champion Automotive — including Clevor builds on the
            stand with Cleveland heads, Trick Flow hardware, and gold rockers.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-4 lg:grid-cols-12 lg:gap-5">
          <Reveal
            variant="image"
            as="figure"
            className="relative overflow-hidden rounded-lg border border-border lg:col-span-7"
          >
            <ResponsiveImage
              image={featured.image}
              alt={featured.alt}
              sizes={imageSizes.galleryFeatured}
              imgClassName="h-[28rem] w-full object-cover sm:h-[34rem]"
              style={{ boxShadow: "var(--shadow-hard)" }}
            />
            <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background/90 via-background/55 to-transparent px-5 pt-16 pb-5">
              <p className="text-[0.65rem] font-semibold tracking-[0.2em] text-primary-text uppercase">
                Featured
              </p>
              <h3 className="mt-1 font-display text-3xl uppercase sm:text-4xl">{featured.title}</h3>
              <p className="mt-1 text-sm text-muted-foreground">{featured.caption}</p>
            </figcaption>
          </Reveal>

          <ul className="grid gap-4 sm:grid-cols-3 lg:col-span-5 lg:grid-cols-1">
            {rest.map((photo, index) => (
              <Reveal
                key={photo.title}
                as="li"
                delay={index * 90}
                variant="image"
                className="h-full"
              >
                <article className="relative h-full overflow-hidden rounded-lg border border-border">
                  <figure className="relative h-full">
                    <ResponsiveImage
                      image={photo.image}
                      alt={photo.alt}
                      sizes={imageSizes.galleryThumb}
                      imgClassName={cn("h-44 w-full object-cover lg:h-40", photo.imgClassName)}
                      style={{ boxShadow: "var(--shadow-hard)" }}
                    />
                    <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background/85 to-transparent px-4 pt-10 pb-3">
                      <h3 className="font-display text-xl uppercase">{photo.title}</h3>
                      <p className="text-xs text-muted-foreground">{photo.caption}</p>
                    </figcaption>
                  </figure>
                </article>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
